import { createSelector } from 'reselect'
import { isCreatingTokenStripeSelect } from 'modules/stripe/redux/selectors/is-creating-token/index.js'
import { isSubscribingStripeSelect } from 'modules/stripe/redux/selectors/is-subscribing/index.js'

export const isLoadingStripeSelect = createSelector(
  isCreatingTokenStripeSelect,
  isSubscribingStripeSelect,
  (isCreatingToken, isSubscribing) => {
    return isCreatingToken || isSubscribing
  }
)
